export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    openPrepaymentInvoiceForm({commit}) {
        commit('setPrepaymentInvoiceFormOpen');
    },
    closePrepaymentInvoiceForm({commit}) {
        commit('setPrepaymentInvoiceFormClose');
    }
}
